<template>
  <tender-form-label :key="index" :label="options.Name" :prop="options.Key" :rules="rules" :error-level="options.ErrorLevel">
    <bear-input v-model="form[options.Key]" v-number-decimal="options.NumberDecimal" :attrs="attrs" @input="inputChangeHandle" :disabled="options.Disabled" @blur="blurSet"></bear-input>
    <span v-if="showRequired" class="bear-required">{{ options.Name }}</span>
  </tender-form-label>
</template>
<script>
import _ from "lodash";
import BearInput from "~@/input/src";
import { mixForFormItem } from "../../../js/mixins";
import utils from "../../../js/utils";
import tenderHook from "../../../js/hooks";
export default {
  name: "FormInputLine",
  mixins: [mixForFormItem],
  components: { BearInput },
  data() {
    return {}
  },
  computed: {
    showRequired() {
      let { form, options } = this;
      return options.ShowRequired && options.Required === false && form[options.Key] === "";
    },
    numberValidWithDecimal() {
      const { Rules = [] } = this.options;
      return Rules.filter((rule) => rule[0] === "numberValidWithDecimal" || rule[0] === "numberValidWithMaxDecimal");
    },
  },
  created() {
    this.setDefaultValue();
  },
  methods: {
    setDefaultValue() {
      let { form = {}, options = {}, param } = this;
      utils
        .readyToSetFormItemDefault(form, options)
        .then(() => {
          options.Init && options.Init(form, true);

          this.setFormItemValue(options.Value || "");

          if (param.firstChange) {
            /* 是否初次触发change事件 */
            this.$nextTick(() => {
              this.inputChangeHandle();
            });
          }
        })
        .catch(() => null);
    },
    inputChangeHandle() {
      tenderHook.refEvent(false, this);
      if (["water", "house", undefined].indexOf(__type__) >= 0) {
        let [rule] = this.numberValidWithDecimal;
        if (!rule) {
          this.doValidate();
        }
      } else {
        this.doValidate();
      }
    },
    blurSet() {
      setTimeout(() => {
        if (["water", "house", undefined].indexOf(__type__) >= 0) {
          const { form = {}, options = {} } = this;
          const value = form[options.Key];
          const [rule] = this.numberValidWithDecimal;
          if (rule) {
            if (rule[2] && rule[2].indexOf(value) >= 0) {
              this.doValidate();
            } else {
              form[options.Key] = isNaN(parseFloat(value)) ? "" : parseFloat(value).toFixed(rule[1]);
              this.doValidate();
            }
          }
        }        
      }, 100)
    },
  },
};
</script>
<style lang="scss" scoped>
.bear-required {
  position: relative;
  display: inline;
  padding: 5px 5px;
  color: var(--el-color-danger);
  background: #eeeeee;
  border-bottom: 1px solid black;
  border-radius: 0 3px 0 0;
}
</style>
